import { DiscountProduct, DiscountProductPrice } from '@/entities/catalog-discount/schema/discount-product.schema'

import { OrderType } from '@/shared/types/product-types'

export const getPriceValue = (price?: DiscountProductPrice | number): number | null => {
	if (price == null) return null

	if (typeof price === 'number') return price

	return price.VALUE ?? null
}

export const getDiscountCondition = (condition?: string | string[] | null): string => {
	if (!condition) return ''

	return Array.isArray(condition) ? condition[0] ?? '' : condition
}

export const getDiscountImages = (item: DiscountProduct): string[] => {
	if (item.IMAGES_RESIZE?.length) return item.IMAGES_RESIZE

	return item.IMAGES ?? []
}

export const isDiscountBuyAvailable = (item: Pick<DiscountProduct, 'ORDER_TYPE'>): boolean =>
	item.ORDER_TYPE !== OrderType.HideBuy
